import {
	Address,
	Model,
	YardSchedule
} from ".";

export default class Customer extends Model {
	get singularNoun() {
		return "customer";
	}

	get mutations() {
		return {
			addresses: Address,
			schedules: YardSchedule
		};
	}

	resource() {
		return "sales/customers";
	}
}
